<template>
<v-row>
    <v-col cols="12" md="12">
        <s-crud no-border formPermanent title="Proyectos Config" height="auto" :config="this.config" @save="save($event)" add edit sortable @rowSelected="rowSelected($event)" searchInput>
            <template slot-scope="props">
                <v-container v-if="props.item != null && ensureDefaults(props.item)" class="pb-0">
                    <v-row justify="center">
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-text v-model="props.item.Proyecto" label="Proyecto" autofocus />
                        </v-col>
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-text v-model="props.item.ProyCorto" label="Proy. Corto" />
                        </v-col>
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-text v-model="props.item.Codigo" label="Código" />
                        </v-col>
                       
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-text v-model="props.item.Etapa" label="Etapa" />
                        </v-col>
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-text v-model="props.item.EtaCorto" label="Eta. Corto" />
                        </v-col>
                        <v-col lg="4" md="4" class="s-col-form">
                            <s-select v-model="props.item.TypeBatch" label="Tipo" :items="itemsTypeBatch" />
                        </v-col>

                        <v-col lg="6" md="6" class="s-col-form">
                            <s-text v-model="props.item.CentroCosto" label="Centro Costo" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-select v-model="props.item.CpyID" label="Empresa" :items="itemsCompany" />
                        </v-col>
                        <v-col lg="3" md="3" class="s-col-form">
                            <s-text v-model="props.item.ProyEtaCorto" label="ProyEtaCorto" />
                        </v-col>
                    </v-row>
                </v-container>
            </template>
            <template v-slot:Proyecto="{ row }">
                <v-row align="center" no-gutters>
                    <v-col>
                        {{ row.Proyecto }}
                    </v-col>
                    <v-col class="text-right" cols="auto">
                        <v-btn x-small color="info" outlined @click.stop="openLotes(row)">Lotes</v-btn>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:CpyID="{ row }">
                {{ getCompanyText(row.CpyID) }}
            </template>
            <template v-slot:TypeBatch="{ row }">
                {{ getTypeBatchText(row.TypeBatch) }}
            </template>
        </s-crud>
    </v-col>

    <v-dialog v-model="dialogLotes" max-width="600">
        <v-card>
            <v-card-title class="headline">
                Lotes - {{ selectedProject ? selectedProject.Proyecto : "" }}
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="9">
                        <s-text v-model="txtNameItem" label="Nombre" />
                    </v-col>
                    <v-col cols="3" class="d-flex align-center">
                        <v-btn outlined color="info" block @click="addLote()">{{ loteActionText }}</v-btn>
                    </v-col>
                </v-row>

                <v-data-table
                    :headers="headersLotes"
                    :items="itemsLotes"
                    dense
                    :items-per-page="5"
                    item-key="PgdID"
                    @click:row="selectLote"
                >
                    <template v-slot:no-data>
                        <div class="py-4">Sin datos</div>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" @click="dialogLotes = false">Cerrar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-row>
</template>

<script>
import _sProjectConfiguration from "@/services/Accounting/ConProjectConfiguration";
export default {
    components: {},
    data: () => ({
        itemsCompany: [
            { value: 1000, text: "IMPISA" },
            { value: 1001, text: "IMPALG" },
        ],
        itemsTypeBatch: [
            { value: 1, text: "LOTE" },
            { value: 2, text: "SUBLOTE" },
        ],
        dialogLotes: false,
        selectedProject: null,
        selectedLote: null,
        txtNameItem: "",
        itemsLotes: [],
        headersLotes: [
            { text: "ID", value: "PgdID", sortable: false },
            { text: "Nombre", value: "NameItem", sortable: false },
            { text: "Estado", value: "SecStatus", sortable: false },
            { text: "Fecha", value: "SecCreate", sortable: false },
        ],
        config: {
            model: {
                PcgID: "ID",
                Proyecto: "string",
                ProyCorto: "string",
                Etapa: "string",
                EtaCorto: "string",
                TypeBatch: "number",
                Codigo: "string",
                CentroCosto: "string",
                CpyID: "number",
                ProyEtaCorto: "string",
            },
            service: _sProjectConfiguration,
            headers: [
                { text: "ID", value: "PcgID", sorteable: false },
                { text: "Proyecto", value: "Proyecto", sorteable: false },
                { text: "Proy. Corto", value: "ProyCorto", sorteable: false },
                { text: "Etapa", value: "Etapa", sorteable: false },
                { text: "Eta. Corto", value: "EtaCorto", sorteable: false },
                { text: "Tipo", value: "TypeBatch", sorteable: false },
                { text: "Código", value: "Codigo", sorteable: false },
                { text: "Centro Costo", value: "CentroCosto", sorteable: false },
                { text: "Empresa", value: "CpyID", sorteable: false },
                { text: "ProyEtaCorto", value: "ProyEtaCorto", sorteable: false },
            ],
        },
    }),
    computed: {
        loteActionText() {
            return this.selectedLote && Number(this.selectedLote.PgdID) > 0 ? "Actualizar" : "Agregar";
        },
    },
    methods: {
        ensureDefaults(item) {
            if (item.CpyID == null || item.CpyID === 0 || item.CpyID === "0" || item.CpyID === "") item.CpyID = 1000;
            if (item.TypeBatch == null || item.TypeBatch === 0 || item.TypeBatch === "0" || item.TypeBatch === "") item.TypeBatch = 1;
            return true;
        },
        getCompanyText(value) {
            const v = typeof value === "string" ? Number(value) : value;
            const found = this.itemsCompany.find((x) => x.value === v);
            return found ? found.text : value;
        },
        getTypeBatchText(value) {
            const v = typeof value === "string" ? Number(value) : value;
            const found = this.itemsTypeBatch.find((x) => x.value === v);
            return found ? found.text : value;
        },
        openLotes(row) {
            this.selectedProject = row;
            this.selectedLote = null;
            this.txtNameItem = "";
            this.itemsLotes = [];
            this.dialogLotes = true;
            this.loadLotes();
        },
        selectLote(item) {
            const currentId = this.selectedLote ? Number(this.selectedLote.PgdID) : 0;
            const nextId = item ? Number(item.PgdID) : 0;
            if (currentId && nextId && currentId === nextId) {
                this.selectedLote = null;
                this.txtNameItem = "";
                return;
            }
            this.selectedLote = item;
            this.txtNameItem = item && item.NameItem != null ? String(item.NameItem) : "";
        },
        loadLotes() {
            if (!this.selectedProject || this.selectedProject.PcgID == null) return;
            _sProjectConfiguration.getDetailProyect(this.selectedProject.PcgID, this.$fun.getUserID()).then(
                (resp) => {
                    const rows = Array.isArray(resp.data) ? resp.data : (resp.data && Array.isArray(resp.data.data) ? resp.data.data : []);
                    this.itemsLotes = rows;
                },
                () => {
                    this.itemsLotes = [];
                }
            );
        },
        addLote() {
            if (!this.selectedProject || this.selectedProject.PcgID == null) return;
            const name = String(this.txtNameItem || "").trim();
            if (!name) {
                this.$fun.alert("Ingrese Nombre", "warning");
                return;
            }
            const pgdId = this.selectedLote && this.selectedLote.PgdID != null ? Number(this.selectedLote.PgdID) : 0;
            const existingSecCreate = this.selectedLote && this.selectedLote.SecCreate ? this.selectedLote.SecCreate : null;
            const secCreate = existingSecCreate || this.$moment(new Date()).format(this.$const.FormatDateTimeDB);
            const detail = {
                PgdID: pgdId,
                PcgID: this.selectedProject.PcgID,
                NameItem: name,
                SecStatus: 1,
                UsrCreateID: this.$fun.getUserID(),
                SecCreate: secCreate,
            };
            _sProjectConfiguration.pydsave(detail, this.$fun.getUserID()).then(() => {
                this.selectedLote = null;
                this.txtNameItem = "";
                this.loadLotes();
            });
        },
        rowSelected() {},
        save(item) {
            item.save();
        },
    },
};
</script>
